export const boardCollision = (
  bounds: Phaser.Geom.Rectangle,
  boardLayer: Phaser.Tilemaps.TilemapLayer,
  door: Phaser.GameObjects.Rectangle | null
) => {
  const doorCollision = door !== null
    ? !Phaser.Geom.Intersects.RectangleToRectangle(bounds, Phaser.Geom.Rectangle.FromPoints([
      { x: door.x, y: door.y },
      { x: door.x + door.width, y: door.y + door.height }
    ]))
    : true;

  return doorCollision
    && boardLayer.getTilesWithinShape(bounds, { isColliding: true }).length < 1;
};